import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import AuthLayout from "../components/global/layout/AuthLayout.jsx";
import AppLayout from "../components/global/layout/Layout.jsx";

const ProtectedRoute = ({ type, children, title, image, accessRole }) => {
  const { loggedIn, userDetails } = useSelector((state) => state.user);

  if (type === "private") {
    if (loggedIn) {
      if (accessRole) {
        if (accessRole === userDetails?.role) {
          return <AppLayout title={title}> {children} </AppLayout>;
        } else {
          return <Navigate to="/dashboard" replace />;
        }
      } else {
        return <AppLayout title={title}> {children} </AppLayout>;
      }
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  if (type === "public") {
    return children;
  }
  
  if (type === "auth") {
    if (!loggedIn) {
      return (
        <AuthLayout image={image} title={title}>
          {children}
        </AuthLayout>
      );
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }
  return;
};

export default ProtectedRoute;
